import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';

import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { DynamicPipe } from '@app/shared/pipes/dynamic-pipe';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { CommonFieldName, NgxsActionName } from '@app/shared/constants';
import { BasedComponent } from '@shared/components/based.component';
import { WebApiResponse } from '@app/shared/classes/general';
import { Terminal } from '@app/shared/classes/terminal';
import { SubRegion } from '@app/shared/classes/subRegion';
import { ReceiverTerminalListComponent } from '@app/pages/team-message/receiver-terminal-list/receiver-terminal-list.component';
import { TerminalIdNamesTranslate } from '@app/shared/pipes/terminal-id-names-translate';
import { SubRegionNamesTranslate } from '@app/shared/pipes/sub-region-names-translate';

@Component({
  selector: 'app-user-profile-data-grid-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AngularMaterialModule, CommonModule, TranslateModule, DynamicPipe, TerminalIdNamesTranslate, SubRegionNamesTranslate],
  template: `
  @if(data[field] === ''){
    <div></div>
  }
  @else {
    @switch (field) {
      @case (commonFieldName.terminalId){
        <span [innerHtml]="data['terminal_ids'] | terminalIdNamesTranslate: (terminals$ | async)"></span>
        @if(data['terminal_ids'] && data['terminal_ids'].length>2){
          <a href="javascript:void(0);" (click)="onTerminalColumnOpen()">
            {{"ml_144130" | translate}}
          </a>
        }
      }
      @case (commonFieldName.subRegion_ids){
        <span [innerHtml]="data['subRegion_ids'] | subRegionNamesTranslate: (subRegions$ | async).data"></span>
      }
      @default {
        <div [innerHtml]="data[field] | dynamicPipe: column.pipe: column.pipeArgs"></div>
      }
    }
  }
  `
})
export class UserProfileDataGridCell extends BasedComponent {
  dialog = inject(MatDialog);

  @Input() data: any;
  @Input() field: string;
  @Input() column: any;

  commonFieldName = CommonFieldName;

  @Select(AppDataState.taskResponse(NgxsActionName.GET_SUB_REGIONS)) subRegions$: Observable<WebApiResponse<SubRegion[]>>;
  @Select(AppDataState.taskResponse(NgxsActionName.GET_DRIVER_RELATED_TERMINAL_LIST)) terminals$: Observable<Terminal[]>;

  constructor() { super(); }

  override ngOnInit() {
    super.ngOnInit();
  }

  onTerminalColumnOpen = () => {
    this.dialog.open(ReceiverTerminalListComponent, {
      width: '700px',
      disableClose: true,
      data: this.data[CommonFieldName.terminal_ids]
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
